import { Maybe } from '../../common/data.js';
import { maybe, parseURL } from '../../common/util.js';
import { IconName } from '../../common/data/icons.js';

export interface SocialWebsite {
	id?: string;
	name?: string;
	icon: IconName;
	hostnames: string[];
}

export const socialWebsites: SocialWebsite[] = [
	{
		id: 'twitter',
		name: 'Twitter',
		icon: 'twitter',
		hostnames: ['twitter.com', 'x.com'],
	},
	{
		id: 'facebook',
		name: 'Facebook',
		icon: 'facebook',
		hostnames: ['facebook.com'],
	},
	{
		id: 'youtube',
		name: 'Youtube',
		icon: 'youtube',
		hostnames: ['youtube.com', 'youtu.be'],
	},
	{
		id: 'instagram',
		name: 'Instagram',
		icon: 'instagram',
		hostnames: ['instagram.com'],
	},
	{
		id: 'twitch',
		name: 'Twitch',
		icon: 'twitch',
		hostnames: ['twitch.tv'],
	},
	{
		id: 'trovo',
		name: 'Trovo',
		icon: 'trovo',
		hostnames: ['trovo.live'],
	},
	{
		id: 'discord',
		name: 'Discord',
		icon: 'discord',
		hostnames: ['discord.com', 'discord.gg'],
	},
	{
		id: 'tiktok',
		name: 'Tiktok',
		icon: 'tiktok',
		hostnames: ['tiktok.com'],
	},
	{
		id: 'patreon',
		name: 'Patreon',
		icon: 'patreon',
		hostnames: ['patreon.com'],
	},
];

export const socialsByHostname = Object.fromEntries(socialWebsites.flatMap(
	w => w.hostnames.flatMap(h => [[h, w], [`www.${h}`, w]])
));

export function socialWebsiteByUrl(url: Maybe<string>) {
	const parsed = maybe(url, parseURL);
	const social = maybe(parsed?.hostname, h => socialsByHostname[h]);
	return social ?? {
		hostnames: [],
		icon: 'web-site',
	};
}
